import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deep-milan',
  templateUrl: './deep-milan.component.html',
  styleUrls: ['./deep-milan.component.scss']
})
export class DeepMilanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
